module.exports = __webpack_public_path__ + "static/media/WireRope2.bb18829f.webp";